import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter, faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <div className='footer'>
      <div className='footer-items'>
        <div className='footer-item'>
          <a href='https://x.com/overload_events'>
            <FontAwesomeIcon icon={faXTwitter} />
          </a>
        </div>

        <div className='footer-item'>
          <a href='https://www.facebook.com/OverloadEventsPokemon/'>
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
        </div>
        <div className='footer-item'>
          <a href='mailto:service@overload-events.com'>
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        </div>
      </div>
      <div className='footer-text'>
        For business inquiries, email service@overload-events.com
      </div>
    </div>
  );
};

export default Footer;
